import { IApiType } from '../types'
import { api as bbbApi, configs as bbbConfigs } from './bbb'
import {
  api as burgerworksApi,
  configs as burgerworksConfigs,
} from './burgerworks'
import { api as commonApi, configs as commonConfigs } from './common'
import { api as dhWbApi, configs as dhWbConfigs } from './dhWb'
import {
  api as fwWingstopApi,
  configs as fwWingstopConfigs,
} from './fwWingstop'
import { api as ghaiPopApi, configs as ghaiPopConfigs } from './ghaiPop'
import { api as irmgBkApi, configs as irmgBkConfigs } from './irmgBk'
import { api as timoneyBkApi, configs as timoneyBkConfigs } from './timoney'
import {
  api as wingitnorthApi,
  configs as wingitnorthConfigs,
} from './wingitnorth'

export type IApiKeyType = keyof typeof api

export const configs = {
  ...commonConfigs,
  ...bbbConfigs,
  ...fwWingstopConfigs,
  ...burgerworksConfigs,
  ...dhWbConfigs,
  ...irmgBkConfigs,
  ...timoneyBkConfigs,
  ...ghaiPopConfigs,
  ...wingitnorthConfigs,
}

export const api = {
  ...commonApi,
  ...bbbApi,
  ...fwWingstopApi,
  ...burgerworksApi,
  ...dhWbApi,
  ...irmgBkApi,
  ...timoneyBkApi,
  ...ghaiPopApi,
  ...wingitnorthApi,
}

const useApi = (apiName: IApiKeyType): IApiType => api[apiName]()

export default useApi
